const initialState = {
  yo: '123',
  paintItemsOnInitialLoad: [],
};

export default initialState;
